export default "__VITE_ASSET__f073342b__"